
import React from 'react';
import { useAuthStore } from '../stores/auth.store';

export default function ImpersonationBanner() {
  const impersonating = useAuthStore((s) => s.impersonating);
  const stopImpersonation = useAuthStore((s) => s.stopImpersonation);

  if (!impersonating) return null;

  return (
    <div
      className="flex items-center justify-center gap-3 px-4 py-2 text-sm font-semibold text-white"
      style={{ backgroundColor: 'var(--wfm-accent)' }}
    >
      <span>
        Stai visualizzando come {impersonating.nome} {impersonating.cognome} &mdash;
      </span>
      <button
        onClick={stopImpersonation}
        className="underline font-bold hover:opacity-80"
      >
        Termina impersonazione
      </button>
    </div>
  );
}
